import { Mail } from "lucide-react";

// Transparent Altura Logo
const ALTURA_LOGO_TRANSPARENT = "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/0eoz3ql5_Screenshot_2026-04-08_at_6.24.02_PM-removebg-preview.png";

const Footer = () => {
  const footerLinks = {
    company: [
      { name: "About Us", href: "#about" },
      { name: "Our Team", href: "#team" },
      { name: "Contact", href: "#contact" }
    ],
    services: [
      { name: "Cabinetry", href: "#services" },
      { name: "Countertops", href: "#services" },
      { name: "Appliances", href: "#services" },
      { name: "Flooring", href: "#services" }
    ],
    resources: [
      { name: "Past Projects", href: "#projects" },
      { name: "Case Studies", href: "#case-studies" },
      { name: "Why Choose Us", href: "#advantages" },
      { name: "Get a Quote", href: "#contact" }
    ]
  };

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand - Transparent logo */}
          <div className="lg:col-span-2">
            <a href="#" className="inline-block mb-6">
              <img 
                src={ALTURA_LOGO_TRANSPARENT} 
                alt="Altura - Factory to Finish" 
                className="h-20 w-auto"
              />
            </a>
            <p className="text-slate-400 mb-6 max-w-sm">
              Your one-stop solution for multifamily interiors. 
              Factory to finish, delivering high quality at the best prices.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="mailto:info@alturasource.com"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-cyan-600 transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Resources</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © 2026 Altura Source. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm">
            Factory to Finish — Multifamily Interior Solutions
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
